import React from 'react';
import Icon from '../../../../components/Icon/Icon';
import { Assistant } from '../../../../services/assistants/Assistants.types';
import { contentfulPortraitUrl, formatCharge } from '../Assistantlistcard/Assistantlistcard';
import './AssistantDialog.css';

type AssistantDialogProps = {
  assistant: Assistant;
  onClose: () => void;
};

const AssistantDialog = ({ assistant, onClose }: AssistantDialogProps) => {
  const dialogRef = React.useRef<HTMLDivElement>(null);
  const closeRef = React.useRef<HTMLButtonElement>(null);
  const portraitUrl = contentfulPortraitUrl(assistant.photo?.url, 900);

  React.useEffect(() => {
    const previousFocus = document.activeElement as HTMLElement | null;
    document.body.classList.add('modal-open');
    closeRef.current?.focus();

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        onClose();
        return;
      }
      if (event.key !== 'Tab' || !dialogRef.current) return;
      const focusable = Array.from(dialogRef.current.querySelectorAll<HTMLElement>('button, [href], [tabindex]:not([tabindex="-1"])'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.classList.remove('modal-open');
      document.removeEventListener('keydown', handleKeyDown);
      previousFocus?.focus();
    };
  }, [onClose]);

  return (
    <div className="assistant-dialog-overlay" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <div ref={dialogRef} className="assistant-dialog" role="dialog" aria-modal="true" aria-labelledby="assistant-dialog-title">
        <button ref={closeRef} type="button" className="assistant-dialog-close" onClick={onClose} aria-label="Cerrar información del auxiliar"><Icon name="close" /></button>
        <div className="assistant-dialog-media">
          {portraitUrl ? (
            <img src={portraitUrl} alt={`Fotografía de ${assistant.name}`} className="assistant-dialog-photo" decoding="async" />
          ) : (
            <span className="assistant-dialog-placeholder" aria-hidden="true">{assistant.name.trim().charAt(0)}</span>
          )}
        </div>
        <div className="assistant-dialog-copy">
          <p className="lis-eyebrow">Integrante del LIS</p>
          <h2 id="assistant-dialog-title">{assistant.name}</h2>
          <p className="assistant-dialog-charge">{formatCharge(assistant.charge)}</p>
          <p className="assistant-dialog-program">{assistant.program}</p>
        </div>
      </div>
    </div>
  );
};

export default AssistantDialog;
